import DaySimpleView from './DaySimpleView'
export default DaySimpleView
